import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import Img from "gatsby-image"

export default function LibraryContent (type) {

  const documents = useStaticQuery(graphql`
    query {
      eBooks:allWordpressPost(filter: {categories: {elemMatch: {name: {eq: "E-books"}}}}) {
        edges {
          node {
            title
            path
            categories {
              id
              name
            }
            featured_media {
              source_url
            }
          }
        }
      }

      studies:allWordpressPost(filter: {categories: {elemMatch: {name: {eq: "Case Studies"}}}}) {
        edges {
          node {
            title
            path
            categories {
              id
              name
            }
            featured_media {
              source_url
            }
          }
        }
      }

      webinars:allWordpressPost(filter: {categories: {elemMatch: {name: {eq: "Webinars"}}}}) {
        edges {
          node {
            title
            path
            categories {
              id
              name
            }
            featured_media {
              source_url
            }
          }
        }
      }

      infographics:allWordpressPost(filter: {categories: {elemMatch: {name: {eq: "Infographics"}}}}) {
        edges {
          node {
            title
            path
            categories {
              id
              name
            }
            featured_media {
              source_url
            }
          }
        }
      }

      videos:allWordpressPost(filter: {categories: {elemMatch: {name: {eq: "Videos"}}}}) {
        edges {
          node {
            title
            path
            slug
            categories {
              id
              name
            }
            featured_media {
              source_url
            }
          }
        }
      }

      whitePapers:allWordpressPost(filter: {categories: {elemMatch: {name: {eq: "White Papers"}}}}) {
        edges {
          node {
            title
            path
            categories {
              id
              name
            }
            featured_media {
              source_url
            }
          }
        }
      }
    }
    `)

    let edges = documents[type.type].edges
    var fallbackImgURL = "https://staging.circadence.com/wp-content/uploads/2020/08/nesa-by-makers-BVr3XaBiWLU-unsplash-1-scaled.jpg"
    let nameConventions = {
      eBooks: "E-Books",
      infographics: "Infographics",
      studies: "Case Studies",
      videos: "Videos",
      whitePapers: "White Papers",
      webinars: "Webinars"
    }

    // if(type.type == "videos"){
    //   console.log("VIDEOS", edges);
    // }

    var container = (
      <div>
        <center id={`cl-${type.type}`} className="cl-content-header"><h2>{nameConventions[type.type]}</h2></center>
        <div className="cl-content-row">
          {
            edges.map((doc) => {
              doc.node.title = doc.node.title.replace("#038;", "")
              doc.node.title = doc.node.title.replace("&#8217;", "'")
              doc.node.title = doc.node.title.replace("&#8211;", "–")
              let buttonLink = linkResolver(doc, type.type)

              return (
                <div className="cl-media">
                  <div className="cl-media-img">
                    <img src={(doc.node.featured_media ? doc.node.featured_media.source_url : fallbackImgURL)} />
                  </div>
                  <div className="cl-media-text">
                    <h4>{doc.node.title}</h4>

                  </div>
                  <div className="cl-media-action">
                    <a href={buttonLink} target="__blank">
                      <button className="flat-button cl-media-button">View</button>
                    </a>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    )

    return (container)
}

function linkResolver (obj, type) {
  if (obj.node.path && type != "videos" && type != "infographics"&&type != "studies") {

    return `https://marketing.circadence.com${obj.node.path}`;

  } else if (type == "infographics" ) {

    return `https://staging.circadence.com${obj.node.path}`;


  }else if (type == "studies"&& obj.node.path.substring( obj.node.path.length-3)=="pdf" ) {

    return `https://staging.circadence.com${obj.node.path}`;


  }
  else if (type == "studies"&& obj.node.path.substring(0, obj.node.path.length-3)!="pdf" ) {

    return `https://marketing.circadence.com${obj.node.path}`;


  }
   else if (type == "videos") {

    return `/videos/${obj.node.slug}`;

  } else {

    return obj.node.link.source_url;

  }
}

// <img src={doc.node.featured_media.source_url} />
